<template>
  <div :class="containerClass">
    <div class="font-bold text-gray-400 uppercase text-base mb-2 flex items-center justify-center gap-2">
      <FlagIcon class="w-4 h-4" />
      <span>{{ title }}</span>
    </div>
    <div v-if="!flags || flags.length === 0" class="text-gray-500 text-sm">
      No flags hit for this curve.
    </div>
    <div v-else class="flex flex-col gap-1 items-center">
      <span 
        v-for="flag in flags" 
        :key="flag.key"
        class="inline-block px-2 py-1 bg-red-100 text-red-800 text-xs font-medium rounded-full"
      >
        {{ flag.label }}
      </span>
    </div>
  </div>
</template>

<script>
import { FlagIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'FlagSummary',
  components: {
    FlagIcon
  },
  props: {
    // Array of flag objects with key and label properties
    flags: {
      type: Array,
      default: () => []
    },
    // Optional: custom styling for flag badges
    flagBadgeClass: {
      type: String,
      default: 'inline-block px-2 py-1 bg-red-100 text-red-800 text-xs font-medium rounded-full'
    },
    // Optional: custom styling for the container
    containerClass: {
      type: String,
      default: 'bg-blue-50 p-4 rounded border-2 border-gray-400 text-center inline-block h-full flex flex-col justify-center'
    },
    // Optional: custom styling for the title
    titleClass: {
      type: String,
      default: 'font-bold text-gray-400 uppercase text-base mb-2'
    },
    // Optional: custom styling for the no flags message
    noFlagsClass: {
      type: String,
      default: 'text-gray-500 text-sm'
    },
    // Optional: custom title text
    title: {
      type: String,
      default: 'Flags'
    },
    // Optional: custom no flags message
    noFlagsMessage: {
      type: String,
      default: 'No flags hit for this curve.'
    }
  },
  computed: {
    // Check if there are any flags
    hasFlags() {
      return this.flags && this.flags.length > 0
    }
  }
}
</script>

<style scoped>
/* Component-specific styles can be added here if needed */
</style>
